module.exports = __webpack_public_path__ + "img/floor_f20_01.21a25a26.png";